import styled from 'styled-components';

import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import { spaceXXL } from '@xing-com/tokens';

import { useHideAside } from '../../hooks';

export const LeftColumn: React.FC<React.PropsWithChildren> = ({ children }) => {
  const hideAside = useHideAside();
  return hideAside ? null : <LeftColumnStyles>{children}</LeftColumnStyles>;
};

const LeftColumnStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceXXL};
  margin-right: ${spaceXXL};

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;
